// // import React, {
// //   Fragment,
// //   useContext,
// //   useEffect,
// //   useRef,
// //   useState,
// // } from "react";
// // import { useTranslation } from "react-i18next";
// // import { Link } from "react-router-dom";
// // import SvgIcon from "../../Components/Common/Component/SvgIcon";
// // import CustomizerContext from "../../_helper/Customizer";
// // import { MENUITEMS } from "./Menu";
// // import IconRenderer from "./IconRenderer";
// // import PrivilegeContext from "../../_helper/PrivilegeContext";
// // import { useClinicAdmin } from "../../_helper/ClinicProvider";

// // const SidebarMenuItems = ({
// //   setMainMenu,
// //   sidebartoogle,
// //   setNavActive,
// //   activeClass,
// // }) => {
// //   const { layout } = useContext(CustomizerContext);
// //   const { clinicAdmin } = useClinicAdmin();
// //   const { privileges } = useContext(PrivilegeContext);
// //   const [menu, setMenu] = useState([]);
// //   const layout1 = localStorage.getItem("sidebar_layout") || layout;
// //   const [hoveredSubmenu, setHoveredSubmenu] = useState(null);
// //   const submenuRef = useRef(null);

// //   const id = window.location.pathname.split("/").pop();
// //   const layoutId = id;
// //   const CurrentPath = window.location.pathname;

// //   const { t } = useTranslation();

// //   // Filter Menu Items Based on Privileges
// //   const filterMenuItems = (menuItems, permissions) => {
// //     return menuItems
// //       .flatMap((menuGroup) => {
// //         // Iterate over each group, accessing the `Items` property
// //         if (menuGroup.Items) {
// //           return menuGroup.Items.filter((menuItem) => {
// //             // console.log(`Checking menu key: ${menuItem.key}`);
// //             const privilege = permissions.find(
// //               (p) => p.menu_key === menuItem.key
// //             );
// //             // console.log(`Privilege found for key ${menuItem.key}:`, privilege);

// //             if (privilege) {
// //               if (privilege.full_access) return true;

// //               if (menuItem.children && menuItem.children.length > 0) {
// //                 menuItem.children = menuItem.children.filter((child) => {
// //                   // console.log(`Checking child menu key: ${child.key}`);
// //                   const childPrivilege = privilege.sub_permissions?.find(
// //                     (sp) => sp.key === child.key
// //                   );
// //                   // console.log(`Child privilege found for key ${child.key}:`, childPrivilege);

// //                   if (childPrivilege) {
// //                     if (childPrivilege.full_access) return true;
// //                     if (
// //                       childPrivilege.actions?.some((action) => action.allowed)
// //                     )
// //                       return true;
// //                   }
// //                   return false;
// //                 });

// //                 return menuItem.children.length > 0;
// //               }

// //               if (!menuItem.children || menuItem.children.length === 0) {
// //                 if (privilege.actions?.some((action) => action.allowed)) {
// //                   return true;
// //                 }
// //               }
// //             }

// //             return false;
// //           });
// //         }
// //         return [];
// //       })
// //       .map((menuItem) => ({ ...menuItem })); // Ensure immutability
// //   };

// //   useEffect(() => {
// //     if (privileges) {
// //       // console.log(JSON.stringify(privileges))
// //       // Filter the menu based on user privileges
// //       // const filteredMenu = filterMenuItems(MENUITEMS, privileges?.permissions || []);

// //       // const transformedMenu = [
// //       //   {
// //       //     Items: filteredMenu
// //       //   }
// //       // ];
// //       // // console.log(JSON.stringify(transformedMenu))

// //       // setMenu(transformedMenu);

// //       setMenu(MENUITEMS);
// //     } else {
// //       console.log("static menus");

// //       // const allowedServices = clinicAdmin.services;
// //       // // Clone the MENUITEMS so original reference is untouched
// //       // const menuCopy = JSON.parse(JSON.stringify(MENUITEMS));

// //       // // Find the services menu item
// //       // const serviceIndex = menuCopy[0].Items.findIndex(item => item.key === 'services');

// //       // if (serviceIndex !== -1) {
// //       //   // Filter children inside 'services' menu based on allowedServices
// //       //   const originalServices = menuCopy[0].Items[serviceIndex];

// //       //   const filteredChildren = originalServices.children.filter(child => {
// //       //     if (child.key === 'pharmacy') return allowedServices.pharmacy;
// //       //     if (child.key === 'laboratory') return allowedServices.laboratory;
// //       //     if (child.key === 'imaging') return allowedServices.imaging;
// //       //     if (child.key === 'special_test') return allowedServices.special_test;
// //       //     if (child.key === 'procedure') return allowedServices.procedure;
// //       //     return false;
// //       //   });

// //       //   // If no services are allowed, remove the entire services menu
// //       //   if (filteredChildren.length === 0) {
// //       //     menuCopy[0].Items.splice(serviceIndex, 1);
// //       //   } else {
// //       //     menuCopy[0].Items[serviceIndex].children = filteredChildren;
// //       //   }
// //       // }
// //       // setMenu(menuCopy);

// //       setMenu(MENUITEMS);
// //     }
// //   }, [privileges]);

// //   const toggletNavActive = (item) => {
// //     if (window.innerWidth <= 991) {
// //       document.querySelector(".page-header").className =
// //         "page-header close_icon";
// //       document.querySelector(".sidebar-wrapper").className =
// //         "sidebar-wrapper close_icon ";
// //       // document.querySelector('.mega-menu-container').classList.remove('d-block');
// //       if (item.type === "sub") {
// //         document.querySelector(".page-header").className = "page-header";
// //         document.querySelector(".sidebar-wrapper").className =
// //           "sidebar-wrapper";
// //       }
// //     }
// //     if (!item.active) {
// //       menu.map((a) => {
// //         a.Items.filter((Items) => {
// //           if (a.Items.includes(item)) Items.active = false;
// //           if (!Items.children) return false;
// //           Items.children.forEach((b) => {
// //             if (Items.children.includes(item)) {
// //               b.active = false;
// //             }
// //             if (!b.children) return false;
// //             b.children.forEach((c) => {
// //               if (b.children.includes(item)) {
// //                 c.active = false;
// //               }
// //             });
// //           });
// //           return Items;
// //         });
// //         return a;
// //       });
// //     }
// //     item.active = !item.active;
// //     setMainMenu({ mainmenu: menu });
// //   };

// //   // return (
// //   //   <>
// //   //     {menu.map((Item, i) => (
// //   //       <Fragment key={i}>
// //   //         {/* <li className="sidebar-main-title">
// //   //           <div>
// //   //             <h6 className="lan-1">{t(Item.menutitle)}</h6>
// //   //           </div>
// //   //         </li> */}
// //   //         {Item.Items.map((menuItem, i) => (
// //   //           <li className="sidebar-list" key={i}>
// //   //             {menuItem.type === "sub" ? (
// //   //               <a
// //   //                 href="javascript"
// //   //                 className={`sidebar-link sidebar-title ${CurrentPath.includes(menuItem.path) ? "active" : ""} ${menuItem.active && "active"}`}
// //   //                 // className={`sidebar-link sidebar-title ${CurrentPath.includes(menuItem.title.toLowerCase()) ? "active" : ""} ${menuItem.active && "active"}`}
// //   //                 onClick={(event) => {
// //   //                   event.preventDefault();
// //   //                   setNavActive(menuItem);
// //   //                   activeClass(menuItem.active);
// //   //                 }}>
// //   //                 <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
// //   //                 <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} />
// //   //                 <span>{t(menuItem.title)}</span>
// //   //                 {menuItem.badge ? <label className={menuItem.badge}>{menuItem.badgetxt}</label> : ""}
// //   //                 <div className="according-menu">{menuItem.active ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}</div>
// //   //               </a>
// //   //             ) : (
// //   //               ""
// //   //             )}

// //   //             {menuItem.type === "link" ? (
// //   //               <Link to={menuItem.path} className={`sidebar-link sidebar-title link-nav  ${CurrentPath.includes(menuItem.path) ? "active" : ""}`} onClick={() => toggletNavActive(menuItem)}>
// //   //                 <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
// //   //                 <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} />
// //   //                 {/* Custom Icons */}
// //   //                 {/* <IconRenderer iconName={menuItem.icon} className="stroke-icon" /> */}
// //   //                 <span>{t(menuItem.title)}</span>
// //   //                 {menuItem.badge ? <label className={menuItem.badge}>{menuItem.badgetxt}</label> : ""}
// //   //               </Link>
// //   //             ) : (
// //   //               ""
// //   //             )}

// //   //             {menuItem.children ? (
// //   //               <ul className="sidebar-submenu" style={layout1 !== "compact-sidebar compact-small" ? (menuItem?.active || CurrentPath.includes(menuItem?.title?.toLowerCase()) ? (sidebartoogle ? { opacity: 1, transition: "opacity 500ms ease-in" } : { display: "block" }) : { display: "none" }) : { display: "none" }}>
// //   //                 {menuItem.children.map((childrenItem, index) => {
// //   //                   return (
// //   //                     <li key={index}>
// //   //                       {childrenItem.type === "sub" ? (
// //   //                         <a
// //   //                           href="javascript"
// //   //                           className={`${CurrentPath.includes(childrenItem?.title?.toLowerCase()) ? "active" : ""}`}
// //   //                           // className={`${childrenItem.active ? 'active' : ''}`}
// //   //                           onClick={(event) => {
// //   //                             event.preventDefault();
// //   //                             toggletNavActive(childrenItem);
// //   //                           }}>
// //   //                           {t(childrenItem.title)}
// //   //                           <span className="sub-arrow">
// //   //                             <i className="fa fa-chevron-right"></i>
// //   //                           </span>
// //   //                           <div className="according-menu">{childrenItem.active ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}</div>
// //   //                         </a>
// //   //                       ) : (
// //   //                         ""
// //   //                       )}

// //   //                       {childrenItem.type === "link" ? (
// //   //                         <Link
// //   //                           to={childrenItem.path}
// //   //                           className={`${CurrentPath.includes(childrenItem?.path) ? "active" : ""}`}
// //   //                           // className={`${childrenItem.active ? 'active' : ''}`} bonusui
// //   //                           onClick={() => toggletNavActive(childrenItem)}>
// //   //                           {t(childrenItem.title)}
// //   //                         </Link>
// //   //                       ) : (
// //   //                         ""
// //   //                       )}

// //   //                       {childrenItem.children ? (
// //   //                         <ul className="nav-sub-childmenu submenu-content" style={CurrentPath.includes(childrenItem?.title?.toLowerCase()) || childrenItem.active ? { display: "block" } : { display: "none" }}>
// //   //                           {childrenItem.children.map((childrenSubItem, key) => (
// //   //                             <li key={key}>
// //   //                               {childrenSubItem.type === "link" ? (
// //   //                                 <Link
// //   //                                   to={childrenSubItem.path}
// //   //                                   className={`${CurrentPath.includes(childrenSubItem?.path) ? "active" : ""}`}
// //   //                                   // className={`${childrenSubItem.active ? 'active' : ''}`}
// //   //                                   onClick={() => toggletNavActive(childrenSubItem)}>
// //   //                                   {t(childrenSubItem.title)}
// //   //                                 </Link>
// //   //                               ) : (
// //   //                                 ""
// //   //                               )}
// //   //                             </li>
// //   //                           ))}
// //   //                         </ul>
// //   //                       ) : (
// //   //                         ""
// //   //                       )}
// //   //                     </li>
// //   //                   );
// //   //                 })}
// //   //               </ul>
// //   //             ) : (
// //   //               ""
// //   //             )}
// //   //           </li>
// //   //         ))}
// //   //       </Fragment>
// //   //     ))}
// //   //   </>
// //   // );

// //   return (
// //     <>
// //       {Array.isArray(menu) &&
// //         menu.map((Item, i) => (
// //           <Fragment key={i}>
// //             {Array.isArray(Item.Items) &&
// //               Item.Items.map((menuItem, j) => (
// //                 <li className="sidebar-list" key={j}>
// //                   {menuItem.type === "sub" ? (
// //                     <a
// //                       href="javascript"
// //                       className={`sidebar-link sidebar-title ${
// //                         CurrentPath.includes(menuItem.path) ? "active" : ""
// //                       } ${menuItem.active ? "active" : ""}`}
// //                       onClick={(event) => {
// //                         event.preventDefault();
// //                         setNavActive(menuItem);
// //                         activeClass(menuItem.active);
// //                       }}
// //                     >
// //                       {/* <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
// //                   <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} /> */}
// //                       {/* Custom Icons */}
// //                       <IconRenderer
// //                         iconName={menuItem.icon}
// //                         className="stroke-icon"
// //                       />
// //                       <span>{t(menuItem.title)}</span>
// //                       {menuItem.badge && (
// //                         <label className={menuItem.badge}>
// //                           {menuItem.badgetxt}
// //                         </label>
// //                       )}
// //                       <div className="according-menu">
// //                         <i
// //                           className={`fa ${
// //                             menuItem.active ? "fa-angle-down" : "fa-angle-right"
// //                           }`}
// //                         ></i>
// //                       </div>
// //                     </a>
// //                   ) : null}

// //                   {menuItem.type === "link" ? (
// //                     <Link
// //                       to={menuItem.path}
// //                       className={`sidebar-link sidebar-title link-nav ${
// //                         CurrentPath.includes(menuItem.path) ? "active" : ""
// //                       }`}
// //                       onClick={(e) => {
// //                         if (CurrentPath === menuItem.path) {
// //                           e.preventDefault(); // Prevent reloading same path
// //                         } else {
// //                           toggletNavActive(menuItem);
// //                         }
// //                       }}
// //                     >
// //                       {/* <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
// //                   <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} /> */}
// //                       {/* Custom Icons */}
// //                       <IconRenderer
// //                         iconName={menuItem.icon}
// //                         className="stroke-icon"
// //                       />
// //                       <span>{t(menuItem.title)}</span>
// //                       {menuItem.badge && (
// //                         <label className={menuItem.badge}>
// //                           {menuItem.badgetxt}
// //                         </label>
// //                       )}
// //                     </Link>
// //                   ) : null}

// //                   {Array.isArray(menuItem.children) &&
// //                   menuItem.children.length > 0 ? (
// //                     <ul
// //                       className="sidebar-submenu"
// //                       style={
// //                         layout1 !== "compact-sidebar compact-small"
// //                           ? menuItem.active ||
// //                             CurrentPath.includes(menuItem.title.toLowerCase())
// //                             ? sidebartoogle
// //                               ? {
// //                                   opacity: 1,
// //                                   transition: "opacity 500ms ease-in",
// //                                 }
// //                               : { display: "block" }
// //                             : { display: "none" }
// //                           : { display: "none" }
// //                       }
// //                     >
// //                       {menuItem.children.map((childrenItem, k) => (
// //                         // <li key={k}>
// //                         <li
// //                           key={k}
// //                           style={{ position: "relative" }}
// //                           onMouseEnter={() => {
// //                             if (
// //                               childrenItem.children &&
// //                               childrenItem.children.length > 0
// //                             ) {
// //                               setHoveredSubmenu(`${j}-${k}`);
// //                             }
// //                           }}
// //                           onMouseLeave={() => setHoveredSubmenu(null)}
// //                         >
// //                           {childrenItem.type === "sub" ? (
// //                             <a
// //                               href="javascript"
// //                               className={
// //                                 CurrentPath.includes(
// //                                   childrenItem.title.toLowerCase()
// //                                 )
// //                                   ? "active"
// //                                   : ""
// //                               }
// //                               onClick={(event) => {
// //                                 event.preventDefault();
// //                                 toggletNavActive(childrenItem);
// //                               }}
// //                             >
// //                               {t(childrenItem.title)}
// //                               <span className="sub-arrow">
// //                                 <i className="fa fa-chevron-right"></i>
// //                               </span>
// //                               <div className="according-menu">
// //                                 <i
// //                                   className={`fa ${
// //                                     childrenItem.active
// //                                       ? "fa-angle-down"
// //                                       : "fa-angle-right"
// //                                   }`}
// //                                 ></i>
// //                               </div>
// //                             </a>
// //                           ) : null}

// //                           {childrenItem.type === "link" ? (
// //                             <Link
// //                               to={childrenItem.path}
// //                               className={
// //                                 CurrentPath.includes(childrenItem.path)
// //                                   ? "active"
// //                                   : ""
// //                               }
// //                               onClick={() => toggletNavActive(childrenItem)}
// //                             >
// //                               {t(childrenItem.title)}
// //                             </Link>
// //                           ) : null}

// //                           {/* {Array.isArray(childrenItem.children) && childrenItem.children.length > 0 ? (
// //                         <ul
// //                           className="nav-sub-childmenu submenu-content"
// //                           style={CurrentPath.includes(childrenItem.title.toLowerCase()) || childrenItem.active ? { display: "block" } : { display: "none" }}
// //                         >
// //                           {childrenItem.children.map((childrenSubItem, l) => (
// //                             <li key={l}>
// //                               {childrenSubItem.type === "link" ? (
// //                                 <Link
// //                                   to={childrenSubItem.path}
// //                                   className={CurrentPath.includes(childrenSubItem.path) ? "active" : ""}
// //                                   onClick={() => toggletNavActive(childrenSubItem)}
// //                                 >
// //                                   {t(childrenSubItem.title)}
// //                                 </Link>
// //                               ) : null}
// //                             </li>
// //                           ))}
// //                         </ul>
// //                       ) : null} */}
// //                           {Array.isArray(childrenItem.children) &&
// //                           childrenItem.children.length > 0 ? (
// //                             <ul
// //                               ref={submenuRef}
// //                               className="nav-sub-childmenu submenu-content"
// //                               style={{
// //                                 display:
// //                                   hoveredSubmenu === `${j}-${k}`
// //                                     ? "block"
// //                                     : "none",
// //                                 position: "absolute",
// //                                 left: "100%",
// //                                 top: "0",
// //                                 minWidth: "200px",
// //                                 zIndex: 1000,
// //                               }}
// //                               onMouseEnter={() =>
// //                                 setHoveredSubmenu(`${j}-${k}`)
// //                               }
// //                               onMouseLeave={() => setHoveredSubmenu(null)}
// //                             >
// //                               {childrenItem.children.map(
// //                                 (childrenSubItem, l) => (
// //                                   <li key={l}>
// //                                     {childrenSubItem.type === "link" ? (
// //                                       <Link
// //                                         to={childrenSubItem.path}
// //                                         className={
// //                                           CurrentPath.includes(
// //                                             childrenSubItem.path
// //                                           )
// //                                             ? "active"
// //                                             : ""
// //                                         }
// //                                         onClick={() =>
// //                                           toggletNavActive(childrenSubItem)
// //                                         }
// //                                       >
// //                                         {t(childrenSubItem.title)}
// //                                       </Link>
// //                                     ) : null}
// //                                   </li>
// //                                 )
// //                               )}
// //                             </ul>
// //                           ) : null}
// //                         </li>
// //                       ))}
// //                     </ul>
// //                   ) : null}
// //                 </li>
// //               ))}
// //           </Fragment>
// //         ))}
// //     </>
// //   );
// // };

// // export default SidebarMenuItems;
// import React, {
//   Fragment,
//   useContext,
//   useEffect,
//   useRef,
//   useState,
// } from "react";
// import { useTranslation } from "react-i18next";
// import { Link } from "react-router-dom";
// import SvgIcon from "../../Components/Common/Component/SvgIcon";
// import CustomizerContext from "../../_helper/Customizer";
// import { MENUITEMS } from "./Menu";
// import IconRenderer from "./IconRenderer";
// import PrivilegeContext from "../../_helper/PrivilegeContext";
// import { useClinicAdmin } from "../../_helper/ClinicProvider";
// import { usePharmacy } from "../../_helper/PharmacyProvider"; // ADD THIS

// // Helper function to check if a feature is enabled in the plan
// const isFeatureEnabled = (featureKey, planFeatures) => {
//   if (!featureKey || !planFeatures) return true;

//   // If featureKey is an array, check if ANY of the features are enabled
//   if (Array.isArray(featureKey)) {
//     return featureKey.some(key => 
//       planFeatures.some(f => f.key === key && f.is_selected)
//     );
//   }

//   // If featureKey is a string, check if that feature is enabled
//   return planFeatures.some(f => f.key === featureKey && f.is_selected);
// };

// const SidebarMenuItems = ({
//   setMainMenu,
//   sidebartoogle,
//   setNavActive,
//   activeClass,
// }) => {
//   const { layout } = useContext(CustomizerContext);
//   const { clinicAdmin } = useClinicAdmin();
//   const { privileges } = useContext(PrivilegeContext);
//   const { pharmacyPOS } = usePharmacy(); // ADD THIS
//   const [menu, setMenu] = useState([]);
//   const layout1 = localStorage.getItem("sidebar_layout") || layout;
//   const [hoveredSubmenu, setHoveredSubmenu] = useState(null);
//   const submenuRef = useRef(null);

//   const id = window.location.pathname.split("/").pop();
//   const layoutId = id;
//   const CurrentPath = window.location.pathname;

//   const { t } = useTranslation();

//   // Check if user is admin
//   const isAdmin = pharmacyPOS?.isAdmin === true || pharmacyPOS?.role === 'admin';

//   // Get plan features from pharmacy data
//   const planFeatures = pharmacyPOS?.planDetail?.features || [];

//   // Filter Menu Items Based on Admin Status and Plan Features
//   const filterMenuByAdminAndPlan = (menuItems) => {
//     return menuItems.map((menuGroup) => {
//       if (menuGroup.Items) {
//         return {
//           ...menuGroup,
//           Items: menuGroup.Items.filter((menuItem) => {
//             // Hide staff & shifts menus if not admin
//             if (
//               !isAdmin &&
//               (menuItem.key === 'staff' || menuItem.key === 'shifts')
//             ) {
//               return false;
//             }

//             // Check if menu item has a feature requirement
//             if (menuItem.featureKey && !isFeatureEnabled(menuItem.featureKey, planFeatures)) {
//               return false;
//             }

//             // Filter children if they exist
//             if (menuItem.children && menuItem.children.length > 0) {
//               menuItem.children = menuItem.children.filter((child) => {
//                 // Hide staff-related items if not admin
//                 if (
//                   !isAdmin &&
//                   (child.key === 'staff' || child.key === 'shifts' || child.key === 'shift_records')
//                 ) {
//                   return false;
//                 }

//                 // Check if child has a feature requirement
//                 if (child.featureKey && !isFeatureEnabled(child.featureKey, planFeatures)) {
//                   return false;
//                 }

//                 return true;
//               });

//               // If all children are filtered out, hide the parent menu
//               return menuItem.children.length > 0;
//             }

//             return true;
//           }),
//         };
//       }
//       return menuGroup;
//     });
//   };

// useEffect(() => {
//   let filteredMenu = JSON.parse(JSON.stringify(MENUITEMS)); // Deep clone to avoid mutating original

//   // Debug logging
//   // console.log('🎯 SidebarMenuItems - Filtering menu:', {
//   //   isAdmin,
//   //   planFeaturesCount: planFeatures.length,
//   //   planFeatures: planFeatures.map(f => ({ key: f.key, is_selected: f.is_selected }))
//   // });

//   // First filter by admin status and plan features
//   filteredMenu = filterMenuByAdminAndPlan(filteredMenu);

//   if (privileges) {
//     // Then filter by privileges if they exist
//     filteredMenu = filterMenuItems(filteredMenu, privileges?.permissions || []);
//   }

//   setMenu(filteredMenu);

//   // console.log('✅ Menu filtered successfully:', filteredMenu[0]?.Items.map(item => item.key));
// }, [privileges, isAdmin, planFeatures]);

//   // Filter Menu Items Based on Privileges
//   const filterMenuItems = (menuItems, permissions) => {
//     return menuItems
//       .flatMap((menuGroup) => {
//         if (menuGroup.Items) {
//           return menuGroup.Items.filter((menuItem) => {
//             const privilege = permissions.find(
//               (p) => p.menu_key === menuItem.key
//             );

//             if (privilege) {
//               if (privilege.full_access) return true;

//               if (menuItem.children && menuItem.children.length > 0) {
//                 menuItem.children = menuItem.children.filter((child) => {
//                   const childPrivilege = privilege.sub_permissions?.find(
//                     (sp) => sp.key === child.key
//                   );

//                   if (childPrivilege) {
//                     if (childPrivilege.full_access) return true;
//                     if (
//                       childPrivilege.actions?.some((action) => action.allowed)
//                     )
//                       return true;
//                   }
//                   return false;
//                 });

//                 return menuItem.children.length > 0;
//               }

//               if (!menuItem.children || menuItem.children.length === 0) {
//                 if (privilege.actions?.some((action) => action.allowed)) {
//                   return true;
//                 }
//               }
//             }

//             return false;
//           });
//         }
//         return [];
//       })
//       .map((menuItem) => ({ ...menuItem }));
//   };


//   const toggletNavActive = (item) => {
//     if (window.innerWidth <= 991) {
//       document.querySelector(".page-header").className =
//         "page-header close_icon";
//       document.querySelector(".sidebar-wrapper").className =
//         "sidebar-wrapper close_icon ";
//       // document.querySelector('.mega-menu-container').classList.remove('d-block');
//       if (item.type === "sub") {
//         document.querySelector(".page-header").className = "page-header";
//         document.querySelector(".sidebar-wrapper").className =
//           "sidebar-wrapper";
//       }
//     }
//     if (!item.active) {
//       menu.map((a) => {
//         a.Items.filter((Items) => {
//           if (a.Items.includes(item)) Items.active = false;
//           if (!Items.children) return false;
//           Items.children.forEach((b) => {
//             if (Items.children.includes(item)) {
//               b.active = false;
//             }
//             if (!b.children) return false;
//             b.children.forEach((c) => {
//               if (b.children.includes(item)) {
//                 c.active = false;
//               }
//             });
//           });
//           return Items;
//         });
//         return a;
//       });
//     }
//     item.active = !item.active;
//     setMainMenu({ mainmenu: menu });
//   };

//   return (
//     <>
//       {Array.isArray(menu) &&
//         menu.map((Item, i) => (
//           <Fragment key={i}>
//             {Array.isArray(Item.Items) &&
//               Item.Items.map((menuItem, j) => (
//                 <li className="sidebar-list" key={j}>
//                   {menuItem.type === "sub" ? (
//                     <a
//                       href="javascript"
//                       className={`sidebar-link sidebar-title ${
//                         CurrentPath.includes(menuItem.path) ? "active" : ""
//                       } ${menuItem.active ? "active" : ""}`}
//                       onClick={(event) => {
//                         event.preventDefault();
//                         setNavActive(menuItem);
//                         activeClass(menuItem.active);
//                       }}
//                     >
//                       <IconRenderer
//                         iconName={menuItem.icon}
//                         className="stroke-icon"
//                       />
//                       <span>{t(menuItem.title)}</span>
//                       {menuItem.badge && (
//                         <label className={menuItem.badge}>
//                           {menuItem.badgetxt}
//                         </label>
//                       )}
//                       <div className="according-menu">
//                         <i
//                           className={`fa ${
//                             menuItem.active ? "fa-angle-down" : "fa-angle-right"
//                           }`}
//                         ></i>
//                       </div>
//                     </a>
//                   ) : null}

//                   {menuItem.type === "link" ? (
//                     <Link
//                       to={menuItem.path}
//                       className={`sidebar-link sidebar-title link-nav ${
//                         CurrentPath.includes(menuItem.path) ? "active" : ""
//                       }`}
//                       onClick={(e) => {
//                         if (CurrentPath === menuItem.path) {
//                           e.preventDefault();
//                         } else {
//                           toggletNavActive(menuItem);
//                         }
//                       }}
//                     >
//                       <IconRenderer
//                         iconName={menuItem.icon}
//                         className="stroke-icon"
//                       />
//                       <span>{t(menuItem.title)}</span>
//                       {menuItem.badge && (
//                         <label className={menuItem.badge}>
//                           {menuItem.badgetxt}
//                         </label>
//                       )}
//                     </Link>
//                   ) : null}

//                   {Array.isArray(menuItem.children) &&
//                   menuItem.children.length > 0 ? (
//                     <ul
//                       className="sidebar-submenu"
//                       style={
//                         layout1 !== "compact-sidebar compact-small"
//                           ? menuItem.active ||
//                             CurrentPath.includes(menuItem.title.toLowerCase())
//                             ? sidebartoogle
//                               ? {
//                                   opacity: 1,
//                                   transition: "opacity 500ms ease-in",
//                                 }
//                               : { display: "block" }
//                             : { display: "none" }
//                           : { display: "none" }
//                       }
//                     >
//                       {menuItem.children.map((childrenItem, k) => (
//                         <li
//                           key={k}
//                           style={{ position: "relative" }}
//                           onMouseEnter={() => {
//                             if (
//                               childrenItem.children &&
//                               childrenItem.children.length > 0
//                             ) {
//                               setHoveredSubmenu(`${j}-${k}`);
//                             }
//                           }}
//                           onMouseLeave={() => setHoveredSubmenu(null)}
//                         >
//                           {childrenItem.type === "sub" ? (
//                             <a
//                               href="javascript"
//                               className={
//                                 CurrentPath.includes(
//                                   childrenItem.title.toLowerCase()
//                                 )
//                                   ? "active"
//                                   : ""
//                               }
//                               onClick={(event) => {
//                                 event.preventDefault();
//                                 toggletNavActive(childrenItem);
//                               }}
//                             >
//                               {t(childrenItem.title)}
//                               <span className="sub-arrow">
//                                 <i className="fa fa-chevron-right"></i>
//                               </span>
//                               <div className="according-menu">
//                                 <i
//                                   className={`fa ${
//                                     childrenItem.active
//                                       ? "fa-angle-down"
//                                       : "fa-angle-right"
//                                   }`}
//                                 ></i>
//                               </div>
//                             </a>
//                           ) : null}

//                           {childrenItem.type === "link" ? (
//                             <Link
//                               to={childrenItem.path}
//                               className={
//                                 CurrentPath.includes(childrenItem.path)
//                                   ? "active"
//                                   : ""
//                               }
//                               onClick={() => toggletNavActive(childrenItem)}
//                             >
//                               {t(childrenItem.title)}
//                             </Link>
//                           ) : null}

//                           {Array.isArray(childrenItem.children) &&
//                           childrenItem.children.length > 0 ? (
//                             <ul
//                               ref={submenuRef}
//                               className="nav-sub-childmenu submenu-content"
//                               style={{
//                                 display:
//                                   hoveredSubmenu === `${j}-${k}`
//                                     ? "block"
//                                     : "none",
//                                 position: "absolute",
//                                 left: "100%",
//                                 top: "0",
//                                 minWidth: "200px",
//                                 zIndex: 1000,
//                               }}
//                               onMouseEnter={() =>
//                                 setHoveredSubmenu(`${j}-${k}`)
//                               }
//                               onMouseLeave={() => setHoveredSubmenu(null)}
//                             >
//                               {childrenItem.children.map(
//                                 (childrenSubItem, l) => (
//                                   <li key={l}>
//                                     {childrenSubItem.type === "link" ? (
//                                       <Link
//                                         to={childrenSubItem.path}
//                                         className={
//                                           CurrentPath.includes(
//                                             childrenSubItem.path
//                                           )
//                                             ? "active"
//                                             : ""
//                                         }
//                                         onClick={() =>
//                                           toggletNavActive(childrenSubItem)
//                                         }
//                                       >
//                                         {t(childrenSubItem.title)}
//                                       </Link>
//                                     ) : null}
//                                   </li>
//                                 )
//                               )}
//                             </ul>
//                           ) : null}
//                         </li>
//                       ))}
//                     </ul>
//                   ) : null}
//                 </li>
//               ))}
//           </Fragment>
//         ))}
//     </>
//   );
// };

// export default SidebarMenuItems;

import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
  useMemo,
} from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import SvgIcon from "../../Components/Common/Component/SvgIcon";
import CustomizerContext from "../../_helper/Customizer";
import { MENUITEMS } from "./Menu";
import IconRenderer from "./IconRenderer";
import PrivilegeContext from "../../_helper/PrivilegeContext";
import { useClinicAdmin } from "../../_helper/ClinicProvider";
import { usePharmacy } from "../../_helper/PharmacyProvider";
import { isFeatureEnabled } from "../../utils/common";
import { useLicense } from "../../_helper/license/LicenseContext";

const SidebarMenuItems = ({
  setMainMenu,
  sidebartoogle,
  setNavActive,
  activeClass,
}) => {
  const { layout } = useContext(CustomizerContext);
  const { clinicAdmin } = useClinicAdmin();
  const { privileges } = useContext(PrivilegeContext);
  const { pharmacyPOS } = usePharmacy();
  const location = useLocation(); // ✅ Get current location
  const [menu, setMenu] = useState([]);
  const [decodedFeatures, setDecodedFeatures] = useState(null); // ✅ Store decoded features
  const layout1 = localStorage.getItem("sidebar_layout") || layout;
  const [hoveredSubmenu, setHoveredSubmenu] = useState(null);
  const submenuRef = useRef(null);
  const { decodeTokenOnly } = useLicense();

  const id = window.location.pathname.split("/").pop();
  const layoutId = id;
  const CurrentPath = location.pathname; // ✅ Use location.pathname instead of window.location

  const { t } = useTranslation();

  // ✅ Decode token once on mount and extract features
  useEffect(() => {
    decodeTokenOnly().then(decoded => {
      if (decoded && decoded.features) {
        setDecodedFeatures(decoded.features);
      }
    });
  }, [decodeTokenOnly]);

  // ✅ Memoize admin status
  const isAdmin = useMemo(() => {
    return pharmacyPOS?.isAdmin === true || pharmacyPOS?.role === "admin";
  }, [pharmacyPOS?.isAdmin, pharmacyPOS?.role]);

  // ✅ Check if a parent menu item should be active (only if child route is active)
  const isParentActive = (menuItem) => {
    if (menuItem.type === "link") {
      // For link type, check if current path includes the item path
      return CurrentPath.includes(menuItem.path);
    }

    if (menuItem.type === "sub" && menuItem.children) {
      // For sub type, check if any child path matches current path
      return menuItem.children.some((child) =>
        CurrentPath.includes(child.path)
      );
    }

    return false;
  };

  // ✅ Filter menu by admin status and plan features
  const filterMenuByAdminAndPlan = (menuItems) => {
    return menuItems.map((menuGroup) => {
      if (menuGroup.Items) {
        return {
          ...menuGroup,
          Items: menuGroup.Items.filter((menuItem) => {
            // Hide staff & shifts menus if not admin
            if (
              !isAdmin &&
              (menuItem.key === "staff" || menuItem.key === "shifts")
            ) {
              return false;
            }

            // Check if menu item has a feature requirement using utility function
            if (
              menuItem.featureKey &&
              !isFeatureEnabled(menuItem.featureKey, decodedFeatures)
            ) {
              return false;
            }

            // Filter children if they exist
            if (menuItem.children && menuItem.children.length > 0) {
              menuItem.children = menuItem.children.filter((child) => {
                // Hide staff-related items if not admin
                if (
                  !isAdmin &&
                  (child.key === "staff" ||
                    child.key === "shifts" ||
                    child.key === "shift_records")
                ) {
                  return false;
                }

                // Check if child has a feature requirement using utility function
                if (
                  child.featureKey &&
                  !isFeatureEnabled(child.featureKey, decodedFeatures)
                ) {
                  return false;
                }

                return true;
              });

              // If all children are filtered out, hide the parent menu
              return menuItem.children.length > 0;
            }

            return true;
          }),
        };
      }
      return menuGroup;
    });
  };

  // ✅ Filter menu items based on user privileges
  const filterMenuByPrivileges = (menuItems, permissions) => {
    return menuItems
      .flatMap((menuGroup) => {
        if (menuGroup.Items) {
          return menuGroup.Items.filter((menuItem) => {
            const privilege = permissions.find(
              (p) => p.menu_key === menuItem.key
            );

            if (privilege) {
              if (privilege.full_access) return true;

              if (menuItem.children && menuItem.children.length > 0) {
                menuItem.children = menuItem.children.filter((child) => {
                  const childPrivilege = privilege.sub_permissions?.find(
                    (sp) => sp.key === child.key
                  );

                  if (childPrivilege) {
                    if (childPrivilege.full_access) return true;
                    if (
                      childPrivilege.actions?.some((action) => action.allowed)
                    )
                      return true;
                  }
                  return false;
                });

                return menuItem.children.length > 0;
              }

              if (!menuItem.children || menuItem.children.length === 0) {
                if (privilege.actions?.some((action) => action.allowed)) {
                  return true;
                }
              }
            }

            return false;
          });
        }
        return [];
      })
      .map((menuItem) => ({ ...menuItem }));
  };

  // ✅ Single useEffect with proper dependency management
  useEffect(() => {
    // Deep clone to avoid mutating original MENUITEMS
    let filteredMenu = JSON.parse(JSON.stringify(MENUITEMS));

    // Step 1: Filter by admin status and plan features
    filteredMenu = filterMenuByAdminAndPlan(filteredMenu);

    // Step 2: Filter by user privileges if they exist
    if (privileges && privileges.permissions) {
      filteredMenu = filterMenuByPrivileges(
        filteredMenu,
        privileges.permissions
      );
    }

    setMenu(filteredMenu);
  }, [privileges, isAdmin, decodedFeatures]);

  // ✅ Toggle navigation active state
  const toggletNavActive = (item) => {
    if (window.innerWidth <= 991) {
      document.querySelector(".page-header").className =
        "page-header close_icon";
      document.querySelector(".sidebar-wrapper").className =
        "sidebar-wrapper close_icon ";
      if (item.type === "sub") {
        document.querySelector(".page-header").className = "page-header";
        document.querySelector(".sidebar-wrapper").className =
          "sidebar-wrapper";
      }
    }
    if (!item.active) {
      menu.map((a) => {
        a.Items.filter((Items) => {
          if (a.Items.includes(item)) Items.active = false;
          if (!Items.children) return false;
          Items.children.forEach((b) => {
            if (Items.children.includes(item)) {
              b.active = false;
            }
            if (!b.children) return false;
            b.children.forEach((c) => {
              if (b.children.includes(item)) {
                c.active = false;
              }
            });
          });
          return Items;
        });
        return a;
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: menu });
  };

  return (
    <>
      {Array.isArray(menu) &&
        menu.map((Item, i) => (
          <Fragment key={i}>
            {Array.isArray(Item.Items) &&
              Item.Items.map((menuItem, j) => (
                <li className="sidebar-list" key={j}>
                  {/* ✅ Render sub menu (expandable) */}
                  {menuItem.type === "sub" ? (
                    <a
                      href="javascript"
                      className={`sidebar-link sidebar-title ${isParentActive(menuItem) ? "active" : ""
                        } ${menuItem.active ? "active" : ""}`}
                      onClick={(event) => {
                        event.preventDefault();
                        setNavActive(menuItem);
                        activeClass(menuItem.active);
                        toggletNavActive(menuItem);
                      }}
                    >
                      <IconRenderer
                        iconName={menuItem.icon}
                        className="stroke-icon"
                      />
                      <span>{t(menuItem.title)}</span>
                      {menuItem.badge && (
                        <label className={menuItem.badge}>
                          {menuItem.badgetxt}
                        </label>
                      )}
                      <div className="according-menu">
                        <i
                          className={`fa ${menuItem.active
                            ? "fa-angle-down"
                            : "fa-angle-right"
                            }`}
                        ></i>
                      </div>
                    </a>
                  ) : null}

                  {/* ✅ Render link menu (direct navigation) */}
                  {menuItem.type === "link" ? (
                    <Link
                      to={menuItem.path}
                      className={`sidebar-link sidebar-title link-nav ${isParentActive(menuItem) ? "active" : ""
                        }`}
                      onClick={(e) => {
                        if (CurrentPath === menuItem.path) {
                          e.preventDefault();
                        } else {
                          toggletNavActive(menuItem);
                        }
                      }}
                    >
                      <IconRenderer
                        iconName={menuItem.icon}
                        className="stroke-icon"
                      />
                      <span>{t(menuItem.title)}</span>
                      {menuItem.badge && (
                        <label className={menuItem.badge}>
                          {menuItem.badgetxt}
                        </label>
                      )}
                    </Link>
                  ) : null}

                  {/* ✅ Render submenu children */}
                  {Array.isArray(menuItem.children) &&
                    menuItem.children.length > 0 ? (
                    <ul
                      className="sidebar-submenu"
                      style={
                        layout1 !== "compact-sidebar compact-small"
                          ? menuItem.active ||
                            isParentActive(menuItem) ||
                            CurrentPath.includes(menuItem.title.toLowerCase())
                            ? sidebartoogle
                              ? {
                                opacity: 1,
                                transition: "opacity 500ms ease-in",
                              }
                              : { display: "block" }
                            : { display: "none" }
                          : { display: "none" }
                      }
                    >
                      {menuItem.children.map((childrenItem, k) => (
                        <li
                          key={k}
                          style={{ position: "relative" }}
                          onMouseEnter={() => {
                            if (
                              childrenItem.children &&
                              childrenItem.children.length > 0
                            ) {
                              setHoveredSubmenu(`${j}-${k}`);
                            }
                          }}
                          onMouseLeave={() => setHoveredSubmenu(null)}
                        >
                          {/* ✅ Render child sub menu */}
                          {childrenItem.type === "sub" ? (
                            <a
                              href="javascript"
                              className={
                                isParentActive(childrenItem)
                                  ? "active"
                                  : ""
                              }
                              onClick={(event) => {
                                event.preventDefault();
                                toggletNavActive(childrenItem);
                              }}
                            >
                              {t(childrenItem.title)}
                              <span className="sub-arrow">
                                <i className="fa fa-chevron-right"></i>
                              </span>
                              <div className="according-menu">
                                <i
                                  className={`fa ${childrenItem.active
                                    ? "fa-angle-down"
                                    : "fa-angle-right"
                                    }`}
                                ></i>
                              </div>
                            </a>
                          ) : null}

                          {/* ✅ Render child link menu */}
                          {childrenItem.type === "link" ? (
                            <Link
                              to={childrenItem.path}
                              className={
                                isParentActive(childrenItem)
                                  ? "active"
                                  : ""
                              }
                              onClick={() => toggletNavActive(childrenItem)}
                            >
                              {t(childrenItem.title)}
                            </Link>
                          ) : null}

                          {/* ✅ Render grandchild items (3rd level) */}
                          {Array.isArray(childrenItem.children) &&
                            childrenItem.children.length > 0 ? (
                            <ul
                              ref={submenuRef}
                              className="nav-sub-childmenu submenu-content"
                              style={{
                                display:
                                  hoveredSubmenu === `${j}-${k}`
                                    ? "block"
                                    : "none",
                                position: "absolute",
                                left: "100%",
                                top: "0",
                                minWidth: "200px",
                                zIndex: 1000,
                              }}
                              onMouseEnter={() =>
                                setHoveredSubmenu(`${j}-${k}`)
                              }
                              onMouseLeave={() => setHoveredSubmenu(null)}
                            >
                              {childrenItem.children.map(
                                (childrenSubItem, l) => (
                                  <li key={l}>
                                    {childrenSubItem.type === "link" ? (
                                      <Link
                                        to={childrenSubItem.path}
                                        className={
                                          isParentActive(childrenSubItem)
                                            ? "active"
                                            : ""
                                        }
                                        onClick={() =>
                                          toggletNavActive(childrenSubItem)
                                        }
                                      >
                                        {t(childrenSubItem.title)}
                                      </Link>
                                    ) : null}
                                  </li>
                                )
                              )}
                            </ul>
                          ) : null}
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              ))}
          </Fragment>
        ))}
    </>
  );
};

export default SidebarMenuItems;